/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner } from './get-teams-card-notification-settings200-response-inner-user-account-groups-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner } from './get-teams-card-notification-settings200-response-inner-user-accounts-inner';

/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInner
 */
export interface GetTeamsCardNotificationSettings200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'channelId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'transactionTypes': Array<GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum>;
    /**
     * 
     * @type {number}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'largeAmountThreshold': number | null;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'userAccounts': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInner>;
    /**
     * 
     * @type {Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner>}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'userAccountGroups': Array<GetTeamsCardNotificationSettings200ResponseInnerUserAccountGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetTeamsCardNotificationSettings200ResponseInner
     */
    'isAllUserAccount': boolean;
}

export const GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum = {
    unknownTransactionType: 'UNKNOWN_TRANSACTION_TYPE',
    successfulTransaction: 'SUCCESSFUL_TRANSACTION',
    incorrectCardInput: 'INCORRECT_CARD_INPUT',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    otherError: 'OTHER_ERROR',
    potentialFraud: 'POTENTIAL_FRAUD',
    criticalError: 'CRITICAL_ERROR',
    unusualUser: 'UNUSUAL_USER',
    limitationByUser: 'LIMITATION_BY_USER',
    unsupportedTransaction: 'UNSUPPORTED_TRANSACTION',
    carelessUser: 'CARELESS_USER'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerTransactionTypesEnum];


